module.exports = __webpack_public_path__ + "img/ar.81fd3c8e.svg";